import React, {FC} from "react";

const Impressum : FC = () => {
    return(
        <div className={"container-sm justify-content-center"}>
            <div className="d-flex justify-content-center">
                <div className={"row"}>
                    <div className={"col p-2"}>
                        <div><h1>Impressum</h1></div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Impressum;